export const Separator = () => <div className="border-primary my-1 border-t" />;
